/**
 * hooks/handlers/registerHooks.ts — UPDATED
 *
 * ADD the new imports and entries at the bottom.
 * Keep all existing entries unchanged.
 */

import {
  DEVICES,
  DEVICE_ORDERS,
  INSTITUTIONS,
  NOTIFICATIONS,
  PRODUCTS,
  // Phase 6
  MANUAL_DEPOSITS,
  MANUAL_WITHDRAWALS,
  MANUAL_REPAYMENTS,
} from "../../constants/constants";
import { useInstallmentsList } from "../installments/useInstallments";
import { useInstitutionsList } from "../instititutions/useInstitutions";
import { useInvestmentPlansList } from "../investments/useInvestmentPlansList";
import { useInvestmentsList } from "../investments/useInvestments";
import { useLoansList } from "../loans/useLoans";
import { useNotificationsList } from "../notifications/useNotificationsList";
import { useProductsList } from "../products/useProducts";
import { useTransactionsList } from "../transactions/useTransactions";
import { useWallet } from "../wallets/useWallet";
import { useDevicesList } from "../devices/useDevicesList";
import { useDeviceOrdersList } from "../devices/useDeviceOrdersList";

// ── Phase 6: Manual Operations ──────────────────────────────────
import { useDepositsList } from "../deposits/useDepositsList";
import { useWithdrawalsList } from "../withdrawals/useWithdrawalsList";
import { useManualRepaymentsList } from "../manual-repayments/useManualRepaymentsList";

export const listHooks: any = {
  loans: useLoansList,
  investments: useInvestmentsList,
  investment_plans: useInvestmentPlansList,
  transactions: useTransactionsList,
  installments: useInstallmentsList,
  wallet: useWallet,
  [INSTITUTIONS]: useInstitutionsList,
  [PRODUCTS]: useProductsList,

  // Device financing
  [DEVICES]: useDevicesList,
  [DEVICE_ORDERS]: useDeviceOrdersList,

  // Notifications
  [NOTIFICATIONS]: useNotificationsList,

  // ── Phase 6: Manual Operations ──
  [MANUAL_DEPOSITS]: useDepositsList,
  [MANUAL_WITHDRAWALS]: useWithdrawalsList,
  [MANUAL_REPAYMENTS]: useManualRepaymentsList,
};